import classnames from 'classnames'
import PropTypes from 'prop-types'

import Logger from '../../../../lib/NewLogger'
import routerUtils from '../../../../lib/routerUtils'


const SecureSharingItems = ({className, currentUser, deputiesOthersActive, myDeputiesActive}) => {
  const logEvent = name => {
    Logger.log({
      name,
      payload: {
        context: 'primary_navigation'
      }
    })
  }

  const goToMyDeputies = () => {
    logEvent('clicked_my_deputies')
    routerUtils.push('cm/deputies')
  }

  const goToDeputyFor = () => {
    logEvent('clicked_im_a_deputy_for')
    routerUtils.push('cm/deputy-for')
  }


  const showDeputyNav = () => currentUser.is_deputy || currentUser.has_pending_deputy_invite

  return (
    <ul className={classnames('nav-group-sublist', className)}>
      <li className={classnames('nav-deputy-link', {active: myDeputiesActive})}>
        <button type='button' onClick={goToMyDeputies}>My Deputies</button>
      </li>
      {
        showDeputyNav() && (
          <li className={classnames('nav-deputy-link', {active: deputiesOthersActive})}>
            <button type='button' onClick={goToDeputyFor}>I'm a Deputy for</button>
          </li>
        )
      }
    </ul>
  )
}

SecureSharingItems.propTypes = {
  className: PropTypes.string,
  currentUser: PropTypes.shape({
    has_invited_deputy: PropTypes.bool,
    has_pending_deputy_invite: PropTypes.bool,
    is_deputy: PropTypes.bool
  }),
  deputiesOthersActive: PropTypes.bool,
  myDeputiesActive: PropTypes.bool
}

export default SecureSharingItems
